<template
  ><div class=" my-2">
    <h3>Loan Review Officer Stats</h3>
    <div class=" row">
      <div
        class="col-xl-4 col-lg-4 col-12 px--5 shadow rounded-1 mt-1 mx-1"
        v-for="(item, index) in kpiArr"
        :key="index"
        style="padding: 0.7rem;"
      >
        <div class="d-flex justify-content-between">
          <div>
            <h2>
              {{ item.first_name }} {{ item.last_name
              }}<span style="font-size: 17px"></span>
            </h2>
          </div>
          <div>
            <ClipboardIcon />
          </div>
        </div>

        <KeyValue
          objKey="Loan Reviewed All Time"
          :objValue="item.loan_reviewed_stats.loan_reviewed_all_time"
          :showBullet="true"
        />
        <KeyValue
          objKey="Loan Reviewed Last Month"
          :objValue="item.loan_reviewed_stats.loan_reviewed_last_month"
          :showBullet="true"
        />
        <KeyValue
          objKey="Loan Reviewed Last Week"
          :objValue="item.loan_reviewed_stats.loan_reviewed_last_week"
          :showBullet="true"
        />
        <KeyValue
          objKey="Loan Reviewed This Month"
          :objValue="item.loan_reviewed_stats.loan_reviewed_this_month"
          :showBullet="true"
        />
        <KeyValue
          objKey="Loan Reviewed This Week"
          :objValue="item.loan_reviewed_stats.loan_reviewed_this_week"
          :showBullet="true"
        />
        <KeyValue
          objKey="Loan Reviewed Today"
          :objValue="item.loan_reviewed_stats.loan_reviewed_today"
          :showBullet="true"
        />
        <KeyValue
          objKey="All Time Approved Reviews"
          :objValue="item.loan_reviewed_stats.approved_reviews"
          :showBullet="true"
        />
        <KeyValue
          objKey="All Time Declined Reviews"
          :objValue="item.loan_reviewed_stats.declined_reviews"
          :showBullet="true"
        />
        <KeyValue
          objKey="All Time Successful Reviews"
          :objValue="item.loan_reviewed_stats.disbursed_reviews"
          :showBullet="true"
        />
        <KeyValue
          objKey="Approved Reviews Today"
          :objValue="item.loan_reviewed_stats.approved_reviews_today"
          :showBullet="true"
        />
        <KeyValue
          objKey="Declined Reviews Today"
          :objValue="item.loan_reviewed_stats.declined_reviews_today"
          :showBullet="true"
        />
        <KeyValue
          objKey="Successful Reviews Today"
          :objValue="item.loan_reviewed_stats.disbursed_reviews_today"
          :showBullet="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import KeyValue from "@/components/KeyValue.vue";
import ApiService from "@/services/api.service";
import { ClipboardIcon, CreditCardIcon } from "vue-feather-icons";
export default {
  name: "ReviewOfficerStat",
  components: {
    KeyValue,
    ClipboardIcon,
    CreditCardIcon
  },
  data() {
    return {
      kpiArr: [],
      kpiLoading: false
    };
  },
  methods: {
    async getStats() {
      try {
        this.kpiLoading = true;
        const res = await ApiService.get(
          "loan/instant/loan_review_officer_stats"
        );
        // console.log(res);
        this.kpiArr = res.data.data;

        // console.log(res.data.data.length);
        this.kpiLoading = false;
      } catch (error) {
        console.log("error.response");
        this.kpiLoading = false;
      }
    }
  },
  mounted() {
    this.getStats();
  }
};
</script>

<style scoped></style>
